import script from "./AdministratorReportCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorReportCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorReportCompetencies.vue?vue&type=style&index=0&id=197c8284&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197c8284"]])

export default __exports__